import { and, isControl, optionIs, rankWith } from "@jsonforms/core";
export default rankWith(40, and(isControl, optionIs("EventSurveyManagement", true)));
